import { createSearchAction } from 'redux-search';
import {
    HORSE_SET_EDIT_MODE,
    UPDATE_SET_EDIT_MODE,
    SET_SUGGESTION_SEARCH_STATE,
} from '../constants/actionTypes';


export function horseSetEditMode(horse, mode) {
    return {
        type: HORSE_SET_EDIT_MODE,
        is_editing: mode,
        horse,
    };
}

export function updateSetEditMode(update, mode) {
    return {
        type: UPDATE_SET_EDIT_MODE,
        is_editing: mode,
        update,
    };
}

export function performSearch(field, value) {
    return {
        ...createSearchAction(field)(value),
        meta: {
            debounce: {
                time: 300,
            },
        },
    };
}

export function setActiveSearch(isSearching) {
    return {
        type: SET_SUGGESTION_SEARCH_STATE,
        is_searching_via_suggestion: isSearching,
    };
}

export function updateHorse(horse) {
    return {
        type: 'HORSE_UPDATE',
        horse,
    };
}